// Copyright (c) 2018 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import KeplerGl from 'kepler.gl';
import { addDataToMap } from 'kepler.gl/actions';

// Kepler.gl actions
import datasets from './datasets'

import nycConfig from './data/nyc-config';

import MoreInfoPanel from './moreInfoPanel';
import Header from './header';
import './app.css'

const MAPBOX_TOKEN = process.env.REACT_APP_MapboxAccessToken; // eslint-disable-line

const App = ({ dispatch }) => {
  useEffect(() => dispatch(addDataToMap({ datasets, config: nycConfig })), []);
  const [isShowMoreInfo, setShowMoreInfo] = useState(false);
  const togleShowMoreInfo = () => setShowMoreInfo(!isShowMoreInfo)

  return (
    <div style={{ position: 'absolute', width: '100%', height: '100%', minHeight: '70vh' }}>
      <div style={{ position: 'absolute', backgroundColor: 'rgba(81, 111, 134, 0.65)', width: '100%', height: '100%', zIndex: 100, display: isShowMoreInfo ? 'block' : 'none' }}></div>
      <MoreInfoPanel onCloseClicked={togleShowMoreInfo} isVisible={isShowMoreInfo} />
      <Header onMoreInfoClick={togleShowMoreInfo} />
      {/* <Button onClick={this.replaceData}>Replace Data</Button> */}
      <AutoSizer>
        {({ height, width }) => (
          <KeplerGl
            mapboxApiAccessToken={MAPBOX_TOKEN}
            id="map"
            width={width}
            height={height - 80}
          />
        )}
      </AutoSizer>
    </div>
  );
}


const mapStateToProps = state => state;
const dispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, dispatchToProps)(App);
